import React from 'react';

const EmailSettings = ({
  emailSettings,
  setEmailSettings,
  handleSaveEmailSettings,
  loading
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">Email Ayarları</h3>
      
      {/* Bilgi Notu */}
      <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-lg mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm">
              <strong>Not:</strong> Eğer bu alanları boş bırakırsanız, sistem otomatik olarak .env dosyasındaki ayarları kullanacaktır.
              <br />Buraya girdiğiniz değerler .env ayarlarını geçersiz kılar.
              <br /><strong>.env Ayarları:</strong> MAIL_HOST, MAIL_PORT, MAIL_USERNAME, MAIL_PASSWORD, MAIL_FROM_ADDRESS
            </p>
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            SMTP Host
          </label>
          <input
            type="text"
            value={emailSettings.mail_host}
            onChange={(e) => setEmailSettings({ ...emailSettings, mail_host: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Port
          </label>
          <input
            type="number"
            value={emailSettings.mail_port}
            onChange={(e) => setEmailSettings({ ...emailSettings, mail_port: parseInt(e.target.value) })}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Email Adresi
        </label>
        <input
          type="email"
          value={emailSettings.mail_username}
          onChange={(e) => setEmailSettings({ ...emailSettings, mail_username: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Email Şifresi
        </label>
        <input
          type="password"
          value={emailSettings.mail_password}
          onChange={(e) => setEmailSettings({ ...emailSettings, mail_password: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Gönderen Email
          </label>
          <input
            type="email"
            value={emailSettings.mail_from_address}
            onChange={(e) => setEmailSettings({ ...emailSettings, mail_from_address: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Gönderen İsmi
          </label>
          <input
            type="text"
            value={emailSettings.mail_from_name}
            onChange={(e) => setEmailSettings({ ...emailSettings, mail_from_name: e.target.value })}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="mail_secure"
          checked={emailSettings.mail_secure}
          onChange={(e) => setEmailSettings({ ...emailSettings, mail_secure: e.target.checked })}
          className="mr-2 text-purple-600 focus:ring-purple-500"
        />
        <label htmlFor="mail_secure" className="text-sm text-gray-700">
          SSL/TLS Kullan
        </label>
      </div>

      <button
        onClick={handleSaveEmailSettings}
        disabled={loading}
        className="w-full bg-purple-600 text-white py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors disabled:bg-gray-400"
      >
        {loading ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
      </button>
    </div>
  );
};

export default EmailSettings;